<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Plans'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (loaded) {
    <tidy-wrapper>
      <ng-container >
        <tidy-row>
          <tidy-filter
            [initValue]="address?.id"
            [items]="addressFilter"
            [fitContent]="true"
            (optionChange)="changeAddress($event)"
            class="align-center" />
        </tidy-row>
        @if (plans?.length == 0) {
          <tidy-alert>
            <tidy-row>
              <tidy-text
                [body]="'No plans booked.'" />
            </tidy-row>
          </tidy-alert>
          <tidy-button
            [text]="'Book Job(s)'"
            [action]="bookJob.bind(this, 'add_job')"
            class="primary" />
        }
        @if (cameFromBookingFlow && plans?.length) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Select what you want to do:'" />
          </tidy-row>
        }
        @for (plan of plans; track plan) {
          @if (plan?.plan_frequency !== 'once') {
            <tidy-card>
              <tidy-row class="vertical-align-middle">
                <tidy-image
                  [src]="'assets/img/icons/blue_sparkle.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="plan?.formatted_plan_with_weekdays_and_times | titlecase" />
              </tidy-row>
              <tidy-row class="vertical-align-center extra-bottom-padding">
                <tidy-text
                  [body]="plan?.team == null ? 'With Pros from TIDY' : ('With ' | translate) + plan?.team?.name" />
              </tidy-row>
              @if (getJobRequestsFromPlan(plan?.id)?.length > 0) {
                <tidy-row [ngClass]="getJobsFromPlan(plan?.id)?.length ? 'vertical-align-center' : 'vertical-align-center extra-bottom-padding'">
                  <tidy-image
                    [src]="'assets/img/date.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="getJobRequestsFromPlan(plan?.id)?.length" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="('Pending Job Request' | translate) + (getJobRequestsFromPlan(plan?.id)?.length > 1 ? ('s' | translate) : '')" />
                  </tidy-row>
                }
                @for (job of getJobsFromPlan(plan?.id); track job; let last = $last) {
                  <tidy-row [ngClass]="last ? 'extra-bottom-padding vertical-align-center' : 'vertical-align-center'">
                    <tidy-image
                      [src]="'assets/img/date.svg'"
                      class="body-size" />
                    <tidy-text
                [body]="(job?.template_data?.job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (job?.template_data?.job?.start_datetime_local | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="'at'" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="job?.template_data?.job?.start_datetime_local | parseDateTime: 'h:mma'" />
                      </tidy-row>
                    }
                    <tidy-card-button (action)="goToReschedulePlan(plan)">
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/arrow-forward-grey.svg'"
                          class="body-size" />
                        <tidy-text
                          [body]="'Reschedule Plan'" />
                      </tidy-row>
                    </tidy-card-button>
                    <tidy-card-button (action)="goToAddOneTimeJob(plan)">
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          [src]="'assets/img/add-grey.svg'"
                          class="body-size" />
                        <tidy-text
                          [body]="'Add One Time Job'" />
                      </tidy-row>
                    </tidy-card-button>
                    @if (!cameFromBookingFlow) {
                      <tidy-card-button (action)="cancelPlan(plan)">
                        <tidy-row class="vertical-align-center">
                          <tidy-image
                            [src]="'assets/img/close-circle-grey.svg'"
                            class="body-size" />
                          <tidy-text
                            [body]="'Cancel Plan'" />
                        </tidy-row>
                      </tidy-card-button>
                    }
                  </tidy-card>
                }
                @if (plan?.plan_frequency === 'once') {
                  <tidy-card>
                    <tidy-row class="vertical-align-center">
                      <tidy-image
                        [src]="'assets/img/icons/blue_sparkle.svg'"
                        class="title-size" />
                      <tidy-text
                        [header]="('One Time Job' | translate) + (getJobsFromPlan(plan?.id)?.length + getJobRequestsFromPlan(plan?.id)?.length > 1 ? ('s' | translate) : '')" />
                    </tidy-row>
                    <tidy-row class="vertical-align-center extra-bottom-padding">
                      <tidy-text
                        [body]="plan?.team == null ? 'With Pros from TIDY' : ('With ' | translate) + plan?.team?.name" />
                    </tidy-row>
                    @if (getJobRequestsFromPlan(plan?.id)?.length > 0) {
                      <tidy-row [ngClass]="getJobsFromPlan(plan?.id)?.length ? 'vertical-align-center' : 'vertical-align-center extra-bottom-padding'">
                        <tidy-image
                          [src]="'assets/img/date.svg'"
                          class="body-size" />
                        <tidy-text
                          [body]="getJobRequestsFromPlan(plan?.id)?.length" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="('Pending Job Request' | translate) + (getJobRequestsFromPlan(plan?.id)?.length > 1 ? ('s' | translate) : '')" />
                        </tidy-row>
                      }
                      @for (job of getJobsFromPlan(plan?.id); track job; let last = $last) {
                        <tidy-row [ngClass]="last ? 'extra-bottom-padding vertical-align-center' : 'vertical-align-center'">
                          <tidy-image
                            [src]="'assets/img/date.svg'"
                            class="body-size" />
                          <tidy-text
                [body]="(job?.template_data?.job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (job?.template_data?.job?.start_datetime_local | parseDateTime: 'MMM d')" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="'at'" /><span>&nbsp;</span>
                              <tidy-text
                                [body]="job?.template_data?.job?.start_datetime_local | parseDateTime: 'h:mma'" />
                            </tidy-row>
                          }
                          <tidy-card-button (action)="goToReschedulePlan(plan)">
                            <tidy-row class="vertical-align-center">
                              <tidy-image
                                [src]="'assets/img/arrow-forward-grey.svg'"
                                class="body-size" />
                              <tidy-text
                                [body]="('Reschedule Job' | translate) + (getJobsFromPlan(plan?.id)?.length + getJobRequestsFromPlan(plan?.id)?.length > 1 ? ('s' | translate) : '')" />
                            </tidy-row>
                          </tidy-card-button>
                          <tidy-card-button (action)="goToAddOneTimeJob(plan)">
                            <tidy-row class="vertical-align-center">
                              <tidy-image
                                [src]="'assets/img/add-grey.svg'"
                                class="body-size" />
                              <tidy-text
                                [body]="'Add Job'" />
                            </tidy-row>
                          </tidy-card-button>
                          @if (!cameFromBookingFlow) {
                            <tidy-card-button (action)="cancelPlan(plan)">
                              <tidy-row class="vertical-align-center">
                                <tidy-image
                                  [src]="'assets/img/close-circle-grey.svg'"
                                  class="body-size" />
                                <tidy-text
                                  [body]="('Cancel Job' | translate) + (getJobsFromPlan(plan?.id)?.length + getJobRequestsFromPlan(plan?.id)?.length > 1 ? ('s' | translate) : '')" />
                              </tidy-row>
                            </tidy-card-button>
                          }
                        </tidy-card>
                      }
                    }
                  </ng-container>
                </tidy-wrapper>
              }

              @if (!loaded) {
                <ion-skeleton-text
                  animated="true"
                  style="margin-top: -50px; width: 100%; height: 100vh; border-radius: 0;" />
              }

            </ng-template>

            @if (!isRightSideContent) {
              <app-scroll-wrapper [templateContent]="content" />
            }

            @if (isRightSideContent) {
              <ion-content class="ion-content-right-column">
                <ng-container *ngTemplateOutlet="content" />
              </ion-content>
            }
